function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
  fill: "#d95d27"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m369.074219 114.863281-52.457031 52.460938-41.042969-41.042969-161.265625 161.269531 102.515625 102.511719-33.390625 33.390625 88.066406 88.066406c133.582031-7.980469 239.558594-118.378906 240.476562-253.75zm0 0",
  fill: "#c7461f"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m327.632812 330.886719c-3.703124-8.234375-6.46875-17.144531-6.46875-32.402344v-10.800781h-65.164062l-21.601562 64.808594zm0 0",
  fill: "#c7a772"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m327.632812 330.886719h-93.234374l21.601562 109.453125h32.761719c30.789062 0 54.007812-23.21875 54.007812-54.007813 0-24.472656-6.328125-37.339843-11.910156-48.691406-1.121094-2.277344-2.207031-4.488281-3.226563-6.753906zm0 0",
  fill: "#e3c281"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m256 287.683594h-65.167969v10.800781c0 15.257813-2.761719 24.167969-6.464843 32.402344l35.816406 21.601562 35.816406-21.601562zm0 0",
  fill: "#e3c281"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m184.367188 330.886719c-1.015626 2.265625-2.105469 4.476562-3.226563 6.753906-5.582031 11.351563-11.910156 24.21875-11.910156 48.695313 0 30.785156 23.21875 54.003906 54.007812 54.003906h32.761719v-109.453125zm0 0",
  fill: "#fedd90"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m256 82.460938-21.601562 108.011718 21.601562 108.011719h87.847656c38.613282 0 64.089844-28.695313 64.089844-64.085937 0-83.914063-60.398438-151.9375-151.9375-151.9375zm0 0",
  fill: "#fedd90"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m104.0625 234.398438c0 35.394531 25.476562 64.085937 64.089844 64.085937h87.847656v-216.023437c-91.539062 0-151.9375 68.023437-151.9375 151.9375zm0 0",
  fill: "#fff2a3"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m343.847656 309.285156h-87.847656c-5.964844 0-10.800781-4.835937-10.800781-10.800781s4.835937-10.800781 10.800781-10.800781h87.847656c30.878906 0 53.289063-22.410156 53.289063-53.285156 0-81.78125-59.359375-141.136719-141.136719-141.136719-5.964844 0-10.800781-4.835938-10.800781-10.800781 0-5.964844 4.835937-10.800782 10.800781-10.800782 23.707031 0 46.078125 4.292969 66.496094 12.765625 19.644531 8.144531 36.992187 19.933594 51.570312 35.035157 28.804688 29.839843 44.671875 70.660156 44.671875 114.9375 0 20.300781-7.316406 39.058593-20.59375 52.816406-13.738281 14.234375-33.023437 22.070312-54.296875 22.070312zm0 0",
  fill: "#fff2a3"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m311.445312 244.480469h21.601563v21.601562h-21.601563zm0 0",
  fill: "#6c533a"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m347.449219 208.476562h21.601562v21.601563h-21.601562zm0 0",
  fill: "#6c533a"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m245.199219 114.863281h21.601562v21.605469h-21.601562zm0 0",
  fill: "#ac8c63"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m256 309.285156h-87.847656c-21.273438 0-40.558594-7.835937-54.296875-22.070312-13.277344-13.753906-20.59375-32.515625-20.59375-52.816406 0-44.277344 15.867187-85.09375 44.671875-114.9375 14.578125-15.101563 31.925781-26.886719 51.570312-35.035157 20.417969-8.46875 42.792969-12.765625 66.496094-12.765625v21.605469c-81.777344 0-141.136719 59.355469-141.136719 141.132813 0 30.875 22.410157 53.285156 53.289063 53.285156h87.847656zm0 0",
  fill: "#fff2a3"
});

var SvgMushroom = function SvgMushroom(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMushroom, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mushroom.d7ffec16.svg";
export { ForwardRef as ReactComponent };